// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"5862":"596f07f6142378ddcbdc","6798":"5b53a622dfe799707c7f","7471":"34493087eb2469ae6e25"}[chunkId] + "";
};